import { formatCurrency } from "./utils";

/**
 * Round to cents and drop negative zero, so -0 / -0.004 never render "-$0.00".
 */
export function roundCents(value: number): number {
  const cents = Math.round(value * 100) / 100;
  return cents === 0 || !Number.isFinite(cents) ? 0 : cents;
}

/** formatCurrency on the cent-rounded value ("$0.00", never "-$0.00"). */
export function formatCents(value: number): string {
  return formatCurrency(roundCents(value));
}

/**
 * A deduction shown as a subtraction ("-$1,234.50"). Zero (or anything that
 * rounds to zero) shows "$0.00" without a minus sign.
 */
export function formatNegativeCurrency(value: number): string {
  const cents = roundCents(value);
  return cents > 0 ? `-${formatCurrency(cents)}` : formatCurrency(0);
}
